export default __webpack_public_path__ + "static/media/botanyeamcet.9991b2e1.png";